import { HDate } from '@shared/src/public-api';

export class Route_eCMRTransportDateDto {
	public moment: HDate;
	public reset: boolean;

	public static buildReset(): Route_eCMRTransportDateDto {
		let result: Route_eCMRTransportDateDto = new Route_eCMRTransportDateDto();
		result.reset = true;
		return result;
	}

	public static build(moment: HDate): Route_eCMRTransportDateDto {
		let result: Route_eCMRTransportDateDto = new Route_eCMRTransportDateDto();
		result.moment = moment;
		return result;
	}
}
